<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>QR Code</v-card-title>

        <v-card-text>
            <div
                style="text-align: center"
            >
                <img
                    :src="image_url"
                />
                <br/>
                
                <a
                    :href="image_download_url"
                >
                    Download
                </a>


            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>


            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default 
{

    data() {
        return {
            dialog: false,
            qr_code_id: null,
        }
    },

    methods: {

        showDialog(qr_code_id)
        {
            this.qr_code_id = qr_code_id;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },
    },

    computed: {
        image_url() {
            if ( this.qr_code_id == null ) return null;

            return this.$rc.qrCodeURL(this.qr_code_id,200,200);
        },

        image_download_url() {
            if ( this.qr_code_id == null ) return null;

            return this.$rc.qrCodeURL(this.qr_code_id,800,800)+"?attachment=true";
        },
    },
}
</script>

<style lang="scss" scoped>
</style>